export const StandardLayout = ({title, content}) => {
    return(
        <div className="container">
            <h1 className="containerTitle">{title}</h1>
            {content}
        </div>
    )
}